<script setup lang="ts">
import { type Component, type HTMLAttributes } from 'vue';
import AtLoader from '@/components/atoms/AtLoader/AtLoader.vue';
import { Button, type ButtonVariants } from '@/components/ui/button';

const {
  variant = 'default',
  size = 'default',
  type = 'submit',
  loading,
  disabled,
  icon,
  class: propsClass,
} = defineProps<{
  variant?: ButtonVariants['variant'];
  size?: ButtonVariants['size'];
  class?: HTMLAttributes['class'];
  loading?: boolean;
  disabled?: boolean;
  icon?: Component;
  type?: HTMLButtonElement['type'];
}>();
</script>

<template>
  <Button
    :variant="variant"
    :size="size"
    :class="propsClass"
    :disabled="loading || disabled"
    :type="type"
  >
    <component
      :is="icon"
      v-if="!loading && icon"
      class="w-4 h-4 -translate-x-1 mr-1"
    />
    <AtLoader v-else-if="loading" size="xs" class="-translate-x-1 mr-1" />
    <slot />
  </Button>
</template>
